export default "__VITE_ASSET__BXShZZBW__"